/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

/* Klaviyo BIS Trigger */
function wait_library(cb, l = 10) {
  if(l-1 <= 0) return;
  try {cb();}
  catch (err) {setTimeout(function () {wait_library(cb, l-1); }, 1000);}
}
function wait_element(path, cb, l = 50) {
  if(l-1 <= 0) return;
  var el = document.querySelectorAll(path);
  if (el.length > 0) {cb();}
  else {setTimeout(function () {wait_element(path, cb, l-1);}, 100);}
}
var klaviyo = klaviyo || [];
window.backinstock_klaviyo_is_ready = 0;
function open_bis_popup() {
	wait_element('.klaviyo-bis-trigger', () => {
		var mEvent = document.createEvent("MouseEvent");
			mEvent.initMouseEvent("click", true, true, window, 0,
			0, 0, 0, 0,
			false, false, false, false,
			0, null);
		document.querySelectorAll('.klaviyo-bis-trigger')[0].dispatchEvent(mEvent);	
	});
}
function load_klaviyo(open_popup = false) {
	if(window.backinstock_klaviyo_is_ready == 1) {
		console.log('load_klaviyo already loaded');
		if(window.location.hash == '#waitlist' || open_popup) {			
			open_bis_popup();
		}
		return;
  }
	$.getScript( "https://a.klaviyo.com/media/js/onsite/onsite.js", function( data, textStatus, jqxhr ) {
		console.log('load klaviyo new');
		klaviyo.init({
			account: "KUaEZs",
			platform: "shopify",
			list: 'VXJY9e',
		});
		klaviyo.enable("backinstock",{ 
			trigger: {
				product_page_text: "Notify Me When Available",
				product_page_class: "btn",
				product_page_text_align: "center",
				product_page_margin: "0px",
				replace_anchor: false
			},
			modal: {
			newsletter_subscribe_label: "Opt in to receive Säker emails.",
			headline: "Waitlist",
			body_content: "Sign up to receive a notification when the {product_name} is back in stock.",
			email_field_label: "Enter email address",
			button_label: "Join",
			subscription_success_label: "You're in! We'll let you know when it's back.",
			footer_content: '',
			drop_background_color: "#000",
			background_color: "#000",
			text_color: "#fff",
			button_text_color: "#000",
			button_background_color: "#fff",
			close_button_color: "#fff",
			error_background_color: "#fcd6d7",
			error_text_color: "#C72E2F",
			success_background_color: "#d3efcd",
			success_text_color: "#1B9500",
			}
		});
		window.backinstock_klaviyo_is_ready = 1;
		console.log('open_popup = ', open_popup);
		if(window.location.hash == '#waitlist' || open_popup) {
			setTimeout(function() {
				open_bis_popup();
			}, 300);
		}
	});
}

wait_library( () => {
  if(window.location.hash == '#waitlist') {
    load_klaviyo();
  }
});

$(document).ready(function () {
	$(document).on('click', '.js-load-typeform', function () {
		$('.size-chart__btns').hide();
		$('.size-chart__form').css('display', 'block');
	});

	$(document).on('click', '.js-chart-back', function () {
		$('.size-chart__btns').css('display', 'block');
		$('.size-chart__form').hide();
	});

    // Klaviyo Join waitlist
    $(document).on('click', '.js-join-waitlist', function () {
      console.log('abc');
      load_klaviyo(true);
    });

	/** Match Size */
	const sizeInputValidate = (elem, value, min, max) => {
		console.log('sizeInputValidate: elem', elem, 'value', value, 'min', min, 'max', max);
		elem.find('.error').remove();
		if ( value < min || value > max ) {
			elem.append('<span class="error">The available number is from '+ min +' to '+ max +'</span>');
			return false;
		} else {
			return true;
		}
	}

	$('.match-size-content .size-input-wrap .unit').on('change', function() {
		var $this = $(this),
			unitVal = $this.val(),
			$parent = $this.closest('.match-size-content'),
			inputElem = $parent.find('.size-input-wrap .input-field');
	
		$parent.find('.size-chart-list .size-block > span').removeClass('active');
		$parent.find('.size-chart-list .size-block > span[data-unit="'+ unitVal +'"]').addClass('active');
		inputElem.trigger('change');
	});

	const sizeCalculation = (validate, unit, inputVal) => {
		var unitText = unit == 'metric' ? 'cm' : 'in';
		var sizeContentElem = $('.match-size-content'),
				recommendedValElem = $('.match-size-content .recommended-value'),
				sizeCalculationElem = $('.match-size-content .size-calculation-wrap'),
				progressMark = $('.size-calculation .size-slider .progressbar .mark');

		console.log('validate', validate, 'unit', unit, 'inputVal', inputVal);
		if ( validate && inputVal > 0 ) {
			sizeContentElem.addClass('calculated');
			sizeCalculationElem.slideDown();

			var recommendedName, recommendedMinVal, recommendedMaxVal; 

			$('.match-size-content .size-chart-list .size-block').each(function() {
				var $this = $(this),
						sizeName = $this.data('name'),
						minVal = $this.data(unit + '-min'),
						maxVal = $this.data(unit + '-max');

				if ( inputVal >= minVal && inputVal <= maxVal ) {
					recommendedName = sizeName, 
					recommendedMinVal = minVal, 
					recommendedMaxVal = maxVal;

					return false;
				}
			});
			
			var sizeDiff = recommendedMaxVal - recommendedMinVal,
					valueDiff = inputVal - recommendedMinVal,
					diffPercent = valueDiff / sizeDiff * 53,
					markPos = 22 + (Math.round(diffPercent * 10) / 10);

			recommendedValElem.find('.size-name').text(recommendedName);
			recommendedValElem.find('.size-values').text('('+ recommendedMinVal +'-'+ recommendedMaxVal +') '+ unitText);
			progressMark.css('left', markPos + '%');
		} else {
			sizeContentElem.removeClass('calculated');
			sizeCalculationElem.slideUp();
		}
	}

	$('.match-size-content .size-input-wrap .input-field').on('change keyup', function(e) {
		var $this = $(this),
			$parent = $this.closest('.match-size-content'),
			unit = $parent.find('.size-input-wrap .unit').val(),
			metricMinVal = parseFloat($parent.find('input.size-min-value[data-unit=metric]').val()),
			metricMaxVal = parseFloat($parent.find('input.size-max-value[data-unit=metric]').val()),
			imperialMinVal = parseFloat($parent.find('input.size-min-value[data-unit=imperial]').val()),
			imperialMaxVal = parseFloat($parent.find('input.size-max-value[data-unit=imperial]').val()),
			validate = true,
			inputVal = parseFloat(e.target.value);
			
		if ( unit == 'metric' ) {
			validate = sizeInputValidate($parent.find('.size-input'), inputVal, metricMinVal, metricMaxVal);
		} else {
			validate = sizeInputValidate($parent.find('.size-input'), inputVal, imperialMinVal, imperialMaxVal);
		}
	
		sizeCalculation(validate, unit, inputVal);
	});

	$('.match-size-wrapper .head-wrapper .video-tutorial-text').on('click', function() {
		$('.tutorial-video-wrap').addClass('shown');
	});

	$('.tutorial-video-wrap .video-content-wrap .close-popup').on('click', function(e) {
    e.preventDefault();

    $('.tutorial-video-wrap').removeClass('shown');
  });

	$('.tutorial-video-wrap').on('click', function(e) {
    if ( ! $(e.target).is('.tutorial-video-wrap .video-content-wrap, .tutorial-video-wrap .video-content-wrap *') ) {
      $('body').removeClass('overflow-hidden');
      $('.tutorial-video-wrap').removeClass('shown');
    }
  });

  $('.js-size-chart').on('click', function () {
    $([document.documentElement, document.body]).animate({
        scrollTop: $(".match-size-wrapper").offset().top - 150
    }, 1000);
  });
  

  $(document).on('click', '.video-tile', function () {
    $('body').addClass('scroll-lock');
    $('.video-popup').addClass('video-popup--active');

    setTimeout(function () {
      $('.video-popup__info').hide();
    }, 3000);

    let index = parseInt($(this).attr('data-index'));
    $('.video-popup__swiper')[0].swiper.slideTo(index);
    $(`.video-wrapper[data-index="${index}"] video`)[0].play();
  });

  $(document).on('click', '.video-popup__close', function () {
    $('body').removeClass('scroll-lock');
    $('.video-popup').removeClass('video-popup--active');

    $(`.video-wrapper video`).each(function () {
      $(this)[0].pause();
    });
  });

  $('.video-popup__swiper')[0].swiper.on('slideChange', function (e) {
    $(`.video-wrapper video`)[0].pause();
    $(`.video-wrapper[data-index="${$('.video-popup__swiper')[0].swiper.activeIndex}"] video`)[0].play();
  });

  $(document).on('click', '.video-wrapper video', function () {
    let video = $(this)[0];
    if (video.paused) {
      video.play();
      let playBtn = $(this).parents('.video-wrapper').find('.video-action__play');
      playBtn.addClass('active');
      setTimeout(function () {
        playBtn.removeClass('active');
      }, 300);
    }
    else {
      video.pause();
      let pauseBtn = $(this).parents('.video-wrapper').find('.video-action__pause');
      pauseBtn.addClass('active');
      setTimeout(function () {
        pauseBtn.removeClass('active');
      }, 300);
    }
  });

  $(document).on('click', '.video-audio__mute', function () {
    let video = $(this).parents('.video-wrapper').find('video')[0];
    video.muted = true;
    $(this).removeClass('active');
    $(this).parents('.video-wrapper').find('.video-audio__unmute').addClass('active');
  });
  
  $(document).on('click', '.video-audio__unmute', function () {
    let video = $(this).parents('.video-wrapper').find('video')[0];
    video.muted = false;
    $(this).removeClass('active');
    $(this).parents('.video-wrapper').find('.video-audio__mute').addClass('active');
  });

  $(document).on('click mousedown touchstart touchend touchmove mousemove mouseup touchcancel', '.video-progress__bar', function (e) {
    let x;
    let width = $(this).width();
    const video = $(this).parents('.video-wrapper').find('video')[0];
    if (e.type == 'touchstart' || e.type == 'touchmove' || e.type == 'touchend' || e.type == 'touchcancel'){
        var touch = e.originalEvent.touches[0] || e.originalEvent.changedTouches[0];
        x = touch.pageX;
    } else if (e.type == 'mousedown' || e.type == 'mouseup' || e.type == 'mousemove' || e.type == 'mouseover'|| e.type=='mouseout' || e.type=='mouseenter' || e.type=='mouseleave') {
        x = e.clientX;
    }
    const scrubTime = (x / width) * video.duration;
    console.log(x);
    video.currentTime = scrubTime;
  });

  $('.video-wrapper video').bind('timeupdate', function () {
    const video = $(this)[0];
    const progressPercentage = (video.currentTime / video.duration) * 100;
    const progressBar = $(this).parents('.video-wrapper').find('.video-progress__bar__inner');
    progressBar.css('width', `${progressPercentage}%`);
  });
});